import { graphql } from "react-relay";
import { AvatarPerson } from "./AvatarPerson";

export const avatarRowFragments = {
  org: graphql`
    fragment AvatarRow_org on Org {
      ...AvatarPerson_org
    }
  `,
  personList: graphql`
    fragment AvatarRow_personList on PersonList {
      list {
        ...AvatarPerson_person
        primaryEmail
      }
    }
  `,
};
